import React from 'react';
import { observer } from 'mobx-react';
import { DragAndDrop } from '@ann/web-components';
import { useFileUpload } from '../../hook/use-file-upload.hook';
import { EmptyDocumentStateContainer } from './EmptyDocumentState.styled';

const EmptyDocumentState = observer(({ folderId, onBack, onUploadComplete }) => {
  const { fileInputRef, fileInputProps, openFileSelector, handleDrop } = useFileUpload({
    onUploadStart: onBack,
    onUploadComplete,
    folderId // Pass folderId to upload files in the current folder
  });

  return (
    <EmptyDocumentStateContainer>
      {/* Hidden input for file selection */}
      <input {...fileInputProps} ref={fileInputRef} />

      <DragAndDrop
        title="No documents added to this folder yet"
        description="Start by uploading your documents. You can also connect them to agents to automate your workflow. Drag and drop here, or click upload documents"
        manualUploadButton={true}
        onUploadClick={openFileSelector}
        onDrop={handleDrop}
        acceptedFileTypes={[".pdf", ".doc", ".docx", ".jpg", ".png", ".xlsx"]}
      />
    </EmptyDocumentStateContainer>
  );
});

export default EmptyDocumentState;

